<template>

    <ui-popup class="ui-tooltip" v-bind="$componentProps('ui-popup')">
        <span>{{ content }}</span>
    </ui-popup>

</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-facing-decorator';

import type { ComponentProps } from '@wittignl/js-core';
import { componentPropsMixin, createComponentMixin } from '@wittignl/js-core';

import type { PopupProps } from './Popup.vue';
import Popup, { popupCompMixin } from './Popup.vue';

@Component({
    name: 'ui-tooltip-popup',
    components: {
        'ui-popup': Popup
    },
    mixins: [componentPropsMixin, popupCompMixin]
})
export default class TooltipPopup extends Vue {

    @Prop({ type: String })
    content: string;

    /* Todo:
    - Render not outside viewport
    - Optional: Show @ click */
}

export type TooltipPopupComp = InstanceType<typeof TooltipPopup>
export type TooltipPopupProps = ComponentProps<TooltipPopupComp> & PopupProps
export const tooltipPopupCompMixin = createComponentMixin(TooltipPopup, popupCompMixin)

</script>
<style src="../../../scss/component/popup/TooltipPopup.scss" lang="scss"></style>